var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoEssentiaGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168,
    height: 167.999,
    viewBox: "0 0 168 167.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11",
    "data-name": "Grupo 11",
    transform: "translate(-170.072 -214.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10",
    "data-name": "Caminho 10",
    d: "M338.072,252.749v-38.2h-168v42.365h0v42.365h168V252.749Z",
    fill: "#b1904e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11",
    "data-name": "Caminho 11",
    d: "M338.072,334.841v-38.2h-168V339h0v42.365h168V334.841Z",
    transform: "translate(0 1.177)",
    fill: "#b1904e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12",
    "data-name": "Caminho 12",
    d: "M336.041,252.932V216.547H172.073V256.9h0v40.349H336.041V252.932Z",
    transform: "translate(0.015 0.015)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13",
    "data-name": "Caminho 13",
    d: "M336.041,335.023V298.638H172.073v40.349h0v40.349H336.041V335.023Z",
    transform: "translate(0.015 1.192)",
    fill: "#b1904e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6",
    "data-name": "Grupo 6",
    transform: "translate(193.351 323.319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4",
    "data-name": "Grupo 4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14",
    "data-name": "Caminho 14",
    d: "M193.176,338.429V322.295h11.417v2.951h-7.982v3.506h7.813V331.7h-7.813v3.749h7.982v2.975Z",
    transform: "translate(-193.176 -322.053)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_15",
    "data-name": "Caminho 15",
    d: "M209.376,333.545a7.075,7.075,0,0,0,5.129,2.176c1.886,0,2.805-.895,2.805-1.814,0-1.209-1.4-1.621-3.266-2.056-2.636-.6-6.022-1.33-6.022-4.934,0-2.684,2.322-4.862,6.119-4.862a8.973,8.973,0,0,1,6.289,2.25l-1.911,2.515a6.882,6.882,0,0,0-4.62-1.765c-1.548,0-2.37.677-2.37,1.644,0,1.088,1.354,1.428,3.216,1.863,2.661.6,6.048,1.4,6.048,4.983,0,2.95-2.1,5.176-6.459,5.176a9.292,9.292,0,0,1-6.845-2.564Z",
    transform: "translate(-193.067 -322.055)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_16",
    "data-name": "Caminho 16",
    d: "M224.959,333.545a7.077,7.077,0,0,0,5.129,2.176c1.886,0,2.805-.895,2.805-1.814,0-1.209-1.4-1.621-3.266-2.056-2.636-.6-6.022-1.33-6.022-4.934,0-2.684,2.321-4.862,6.119-4.862a8.973,8.973,0,0,1,6.289,2.25L234.1,326.82a6.882,6.882,0,0,0-4.62-1.765c-1.548,0-2.37.677-2.37,1.644,0,1.088,1.354,1.428,3.217,1.863,2.66.6,6.047,1.4,6.047,4.983,0,2.95-2.1,5.176-6.458,5.176a9.293,9.293,0,0,1-6.846-2.564Z",
    transform: "translate(-192.794 -322.055)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_17",
    "data-name": "Caminho 17",
    d: "M239.907,338.429V322.295h11.417v2.951h-7.982v3.506h7.813V331.7h-7.813v3.749h7.982v2.975Z",
    transform: "translate(-192.583 -322.053)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_18",
    "data-name": "Caminho 18",
    d: "M266.985,338.429l-7.691-10.837v10.837h-3.436V322.295h3.532l7.474,10.449V322.295H270.3v16.134Z",
    transform: "translate(-192.371 -322.053)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_19",
    "data-name": "Caminho 19",
    d: "M278.414,338.429v-13.11H273.7v-3.024h12.868v3.024h-4.692v13.11Z",
    transform: "translate(-192.149 -322.053)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20",
    "data-name": "Caminho 20",
    d: "M289.96,338.429V322.295h3.435v16.134Z",
    transform: "translate(-191.887 -322.053)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_21",
    "data-name": "Caminho 21",
    d: "M309.53,338.429l-1.016-2.782h-7.207l-1.017,2.782h-3.773l6.241-16.134h4.305l6.216,16.134Zm-4.62-13.158-2.684,7.4h5.345Z",
    transform: "translate(-191.838 -322.053)",
    fill: "#1a1818"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5",
    "data-name": "Grupo 5",
    transform: "translate(31.341 22.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22",
    "data-name": "Caminho 22",
    d: "M229.574,344.553a4.9,4.9,0,0,1,4.331,2.29l-1.851,1a2.973,2.973,0,0,0-2.48-1.317,3.439,3.439,0,0,0,0,6.871,3.54,3.54,0,0,0,2.26-.8V351.33h-2.793v-1.913h4.988v4a5.806,5.806,0,0,1-4.456,1.977,5.422,5.422,0,1,1,0-10.841Z",
    transform: "translate(-224.006 -344.553)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_23",
    "data-name": "Caminho 23",
    d: "M242.881,355.188l-2.055-3.749h-1.631v3.749h-2.228V344.724h4.894a3.258,3.258,0,0,1,3.514,3.373,3,3,0,0,1-2.29,3.106l2.353,3.984Zm-1.35-8.549h-2.337v2.886h2.337a1.448,1.448,0,1,0,0-2.886Z",
    transform: "translate(-223.908 -344.552)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24",
    "data-name": "Caminho 24",
    d: "M253.188,344.553a5.412,5.412,0,1,1-5.458,5.412A5.258,5.258,0,0,1,253.188,344.553Zm0,1.977a3.445,3.445,0,1,0,3.186,3.435A3.164,3.164,0,0,0,253.188,346.53Z",
    transform: "translate(-223.826 -344.553)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_25",
    "data-name": "Caminho 25",
    d: "M261.393,344.724h2.258v6.213a2.417,2.417,0,1,0,4.832,0v-6.213h2.258V351c0,2.6-1.49,4.377-4.658,4.377-3.2,0-4.69-1.789-4.69-4.361Z",
    transform: "translate(-223.722 -344.552)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26",
    "data-name": "Caminho 26",
    d: "M273.979,355.188V344.724h4.893a3.361,3.361,0,1,1,0,6.715h-2.665v3.749Zm4.6-8.549h-2.368v2.886h2.368a1.446,1.446,0,1,0,0-2.886Z",
    transform: "translate(-223.627 -344.552)",
    fill: "#1a1818"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7",
    "data-name": "Grupo 7",
    transform: "translate(233.717 236.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27",
    "data-name": "Caminho 27",
    d: "M260.146,243.012l-5.483,5.483,2.739,2.738L256.03,252.6l-1.37-1.371h0l-1.37-1.37-2.742,2.742-1.371-1.371,2.745-2.745v0h0l-4.111-4.11h0l-4.112,4.112h0l0,0,2.742,2.742-1.367,1.367-4.112-4.112,6.313-6.313h8.225l-3.57,3.569,1.371,1.371,4.94-4.94h0l1.939-1.939h0v0l-1.237,0H246.469l0,0-8.256,8.256,1.37,1.371,0,0,4.113,4.113,1.37,1.37,1.371-1.37h0l1.367-1.367,1.37,1.37-1.37,1.371h0l-1.371,1.37,2.742,2.742-1.37,1.37-2.746-2.745v0h0l-4.111,4.11,1.37,1.371,1.374,1.374h0l1.371,1.37,2.742-2.742,1.367,1.367-4.113,4.113-6.313-6.312v-8.225l3.57,3.569,1.37-1.37-4.94-4.94v0l-1.939-1.939v0l0,0,0,1.233v12.473h0l0,0,8.257,8.256,1.37-1.37,0,0,5.483-5.483-2.739-2.738,1.371-1.371,1.37,1.371h0l1.37,1.37,2.742-2.742L257.4,262.2l-2.745,2.745v0h0l4.111,4.111h0l2.745-2.746,1.367-1.367,0,0-2.742-2.742,1.367-1.367,4.112,4.112-6.312,6.313h-8.225l3.57-3.569-1.371-1.371-4.94,4.94h0L246.4,273.2h0l0,0,1.238,0h12.468l0,0,8.256-8.256L267,263.57l0,0-4.113-4.113h0l-1.37-1.37-1.371,1.37h0l-1.367,1.367-1.37-1.37,1.37-1.37h0l1.371-1.371-2.742-2.742,1.37-1.37,2.746,2.745v0h0l4.111-4.11h0l-1.37-1.371-1.374-1.374-1.367-1.367,0,0-2.742,2.742L257.4,248.5l4.113-4.113,6.313,6.314v8.225l-3.57-3.57-1.37,1.37,4.94,4.94v0l1.939,1.939V249.9h0l0,0-8.257-8.256-1.37,1.371Zm-13.711,5.479,1.374-1.374,1.371,1.371-1.374,1.374Zm-1.37,15.079L243.69,262.2l1.37-1.37,1.374,1.374Zm15.079,1.371-1.374,1.374-1.371-1.371,1.374-1.374ZM253.288,252.6l1.371,1.37-1.371,1.371-1.37-1.371Zm-4.112,4.112,1.371-1.37,1.37,1.37-1.37,1.371Zm4.112,4.112-1.37-1.37,1.37-1.37,1.371,1.37Zm4.113-4.112-1.371,1.371-1.37-1.371,1.37-1.37Zm4.112-6.854,1.374,1.374-1.37,1.37-1.374-1.374Z",
    transform: "translate(-232.934 -236.361)",
    fill: "#b1904e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28",
    "data-name": "Caminho 28",
    d: "M261.749,236.39H244.887l-11.924,11.924v16.863L244.887,277.1h16.862l11.924-11.924V248.314Zm9.985,27.984-10.788,10.788H245.69L234.9,264.374V249.117l10.788-10.788h15.256l10.788,10.788Z",
    transform: "translate(-232.963 -236.39)",
    fill: "#b1904e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEssentiaGroup);
export default __webpack_public_path__ + "static/media/logo-essentia-group.e8d0147f508f5fe21f3c5567f8707a82.svg";
export { ForwardRef as ReactComponent };